import React, { useState } from "react";
import { FilterWrapper, MarketplaceFilterButton, MarketplaceFilterDropdown, MarketplaceFilterDropdownRow } from "./MarketplaceFilter.styled";
import ton_logo from "../../../assets/img/ton-logo.svg";

export const PriceFilter = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [priceFrom, setPriceFrom] = useState("");
  const [priceTo, setPriceTo] = useState("");

  return (
    <FilterWrapper
      onMouseLeave={() => {
        setShowDropdown(false);
      }}>
      <MarketplaceFilterButton
        onMouseEnter={() => {
          setShowDropdown(true);
        }}>
        $ Price
      </MarketplaceFilterButton>

      <MarketplaceFilterDropdown showDropdown={showDropdown}>
        <h6>
          <img src={ton_logo} alt='logo' />
          TON
        </h6>
        <MarketplaceFilterDropdownRow>
          <input placeholder='From' onChange={(e) => setPriceFrom(e.target.value)} value={priceFrom} />
          <input placeholder='To' onChange={(e) => setPriceTo(e.target.value)} value={priceTo} />
        </MarketplaceFilterDropdownRow>
        <MarketplaceFilterDropdownRow>
          <button>Cleаr</button> <button disabled={priceFrom.length < 1 && priceTo.length < 1}>Apply</button>
        </MarketplaceFilterDropdownRow>
      </MarketplaceFilterDropdown>
    </FilterWrapper>
  );
};
